import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { useAuth } from "react-oidc-context";
import { LinkContainer } from 'react-router-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import API, { GenericAddResponse, IErrorResult } from '../../common/API';
import { AddDeploymentFromTenantResponse, LinkedServer } from '../../common/LinkedServer';
import { FindResponse } from '../../common/Type';
import { Address, AddressEditorComponent } from '../../components/shared/AddressEditorComponent';
import { Contact, ContactEditorComponent } from '../../components/shared/ContactEditorComponent';
import { ErrorModalComponent } from '../../components/shared/ErrorModalComponent';

type LinkedDeploymentParams = {
    linkedTenantId?: string
}

export function LinkDeploymentComponent() {
    const auth = useAuth();
    const navigate = useNavigate()
    const { linkedTenantId } = useParams<LinkedDeploymentParams>();

    const [errorMsg, setErrorMsg] = React.useState<string|undefined>();

    const [serverName, setServerName] = React.useState<string>();
    const [serverId, setServerId] = React.useState<number>();

    const [name, setName] = React.useState<string>("");
    const [desc, setDesc] = React.useState<string>("");

    const [address, setAddress] = React.useState<Address|null>(null);
    const [contact, setContact] = React.useState<Contact | null>(null);

    React.useEffect(() => {
        const getLinkedServer = async () => {
            const response: FindResponse<LinkedServer> | null = await API.get("/api/v1/linkedServer/ByTenantId/" + linkedTenantId, auth);
            if (response == null || response.result.tenants.length === 0)
                return;

            const tenant = response.result.tenants[0];


            setServerName(response.result.name);
            setServerId(response.result.id);

            setName(tenant.name);
        }
        getLinkedServer();
    }, [auth, linkedTenantId])

    const submit = async (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();

        const req = {
            name: name,
            description: desc,
            contact: contact,
            address: {
                street: address?.street,
                city: address?.city,
                postalCode: address?.postalCode,
                stateName: address?.state,
                countryName: address?.country
            }
        }

        try {
            const response: AddDeploymentFromTenantResponse | null = await API.post("/api/v1/linkedServer/Tenant/" + linkedTenantId, req, auth);

            if (response != null)
                navigate("/license/create/" + response.id + "/" + response.accountNumber);

        } catch (e) {
            console.log(e, API.isErrorResponse(e));
            if (API.isErrorResponse(e)) {
                if (e.errors.hasOwnProperty('Error')) {
                    setErrorMsg(e.errors['Error']);
                } else {
                    setErrorMsg(e.title as string)
                }
            } 
            console.log(e);
        }

    }
    
    // Create a new deployment from a tenant
    return (
        <div>
            <ErrorModalComponent errorMessage={errorMsg} onHide={() => setErrorMsg(undefined)} />
            <div className="d-flex justify-content-between mb-3">
                <h1 className="header-text d-flex align-items-center">
                    <FontAwesomeIcon icon="server" className="fs-3 me-2" />
                    <LinkContainer to={"/linkedServers"}>
                        <a>
                            Linked Servers
                        </a>
                    </LinkContainer>

                    <FontAwesomeIcon icon="arrow-right" className="fs-3 mx-2" />
                    <LinkContainer to={"/linkedServers/" + serverId}>
                        <a>
                            {serverName}
                        </a>
                    </LinkContainer>
                    <FontAwesomeIcon icon="arrow-right" className="fs-3 mx-2" />
                    Create Deployment
                </h1>
            </div>

            <form onSubmit={submit}>
                <div className="row">
                    <div className="col-xxl-4">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-0">
                                    <FontAwesomeIcon icon="building" className="pe-1" />
                                    Deployment
                                </h5>
                            </div>
                            <div className="card-body">
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="name" placeholder="Name" value={name} onChange={e => setName(e.target.value)} />
                                    <label htmlFor="name">Name</label>
                                </div>
                                <div className="form-floating mb-3">
                                    <input className="form-control" id="desc" placeholder="Description" value={desc} style={{ height: '100px' }} onChange={(e) => setDesc(e.target.value)} />
                                    <label htmlFor="desc">Description</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-0">
                                    <FontAwesomeIcon icon="map-marker" className="pe-1" />
                                    Address
                                </h5>
                            </div>
                            <div className="card-body">
                                 <AddressEditorComponent address={address} onAddressChange={(addr, isValid) => setAddress(addr)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-4">
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="card-title mb-0">
                                    <FontAwesomeIcon icon="person" className="pe-1" />
                                    Contact
                                </h5>
                            </div>
                            <div className="card-body">
                                <ContactEditorComponent contact={contact} onContactChange={(contact, isValid) => setContact(contact)} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                        <FontAwesomeIcon icon="check" />
                        Add
                    </button>
                </div>
            </form>
        </div>
    )
}